import { ReactNode } from 'react'
import { withIdleTimer, IdleTimerComponent, IIdleTimer } from 'react-idle-timer'

interface IAppProps extends IIdleTimer {
  children: ReactNode;
}

class AppComponent extends IdleTimerComponent<IAppProps> {
  render(): ReactNode {
    return (this.props.children)
  }
}

export const IdleTimer = withIdleTimer<IAppProps>(AppComponent)